import { lazyModal } from "./lazyModal";

// Kept in its own module so both App (modal registration) and useGenericModals (preloading
// before opening) can use it without pulling WelcomeModal and react-markdown into the main bundle
export const LazyWelcomeModal = lazyModal(() =>
  import("./WelcomeModal").then((module) => module.WelcomeModal)
);

export const loadWelcomeModalTitle = () =>
  import("./WelcomeModal").then((module) => module.WelcomeModalTitle);
